import React from 'react';

export type BookingStatus = 'pending' | 'confirmed' | 'completed' | 'cancelled';

interface BadgeProps {
  status?: BookingStatus;
  className?: string;
  children: React.ReactNode;
}

const statusStyles: Record<BookingStatus, string> = {
  pending: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  confirmed: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
  completed: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  cancelled: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
};

const neutralStyle = 'bg-line text-ink-muted';

export const Badge: React.FC<BadgeProps> = ({ status, className = '', children }) => (
  <span
    className={`inline-flex items-center px-2.5 py-1 rounded-sm label-caps ${
      status ? statusStyles[status] : neutralStyle
    } ${className}`}
  >
    {children}
  </span>
);
